export default __webpack_public_path__ + "static/media/grafema_the-creativity-virus_14.ee888c41.jpg";